import { Component, HostBinding, OnInit, TemplateRef } from '@angular/core';
import { HaloModalOptions } from './halo-modal-interface';
import { HaloModalService } from './halo-modal.service';

@Component({
  selector: 'app-halo-modal',
  templateUrl: './halo-modal.component.html',
  styleUrls: ['./halo-modal.component.scss'],
})
export class HaloModalComponent {
  constructor(public service: HaloModalService) {}

  onDismiss(option: HaloModalOptions | null) {
    // execute the call back.
    if (typeof option?.onDismiss == 'function') {
      option.onDismiss();
    }

    this.service.onDismissed();
  }
}
